import React, { useState, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { StyledUnavailableSeatsWrapper, ExpandableSection, StyledExpand, StyledChevron } from './UnavailableSeat.styles';
import { groupSeatsByReference } from 'components/shared/SeatSelection/SeatSelection.utils';
import UnavailableByBooking from './UnavailableByBooking';
import UnavailableByClass from './UnavailableByClass';
import UnavailableAsBlocked from './UnavailableAsBlocked';

const UnavailableSeat = ({ unavailableSeatsWithBookings = [], unavailableSeatsWithoutBookings = [], currentCoach, reference }) => {
  const [isOpen, setOpen] = useState(true);
  const [shouldTransition, setShouldTransition] = useState(false);
  const onToggle = () => {
    setOpen(!isOpen);
    setShouldTransition(true);
  };
  useEffect(() => {
    setOpen(false);
    setShouldTransition(false);
  }, [currentCoach]);

  const seatsTakenByBookings = groupSeatsByReference({ bookingReference: reference, seats: unavailableSeatsWithBookings });
  const seatsBlocked = unavailableSeatsWithoutBookings.filter(({ blocked, inventoryClass }) => blocked || inventoryClass === '');
  const seatsForDifferentInventoryclass = unavailableSeatsWithoutBookings.filter(
    ({ blocked, inventoryClass }) => !blocked && inventoryClass !== ''
  );
  const showUnavailableSeatsDetails =
    seatsBlocked.length > 0 || seatsForDifferentInventoryclass.length > 0 || unavailableSeatsWithBookings.length > 0;

  return (
    <>
      {showUnavailableSeatsDetails && (
        <>
          <StyledUnavailableSeatsWrapper isOpen={isOpen} onClick={onToggle} data-testid="expand-action">
            <StyledExpand data-testid="expand-message">
              <span>
                {isOpen ? <FormattedMessage id="unavailableSeats.hideSeats" /> : <FormattedMessage id="unavailableSeats.showSeats" />}
              </span>
              <StyledChevron shouldTransition={shouldTransition} isOpen={isOpen}>
                <strong>{' > '}</strong>
              </StyledChevron>
            </StyledExpand>
            <span data-testid="expand-numbers">
              (<FormattedMessage id="unavailableSeats.numbersWithBookings" /> {unavailableSeatsWithBookings.length})
            </span>
          </StyledUnavailableSeatsWrapper>

          {isOpen && (
            <ExpandableSection>
              {seatsBlocked.length > 0 && <UnavailableAsBlocked seats={seatsBlocked} />}
              {seatsForDifferentInventoryclass.length > 0 && <UnavailableByClass seats={seatsForDifferentInventoryclass} />}
              {unavailableSeatsWithBookings.length > 0 && <UnavailableByBooking seats={seatsTakenByBookings} />}
            </ExpandableSection>
          )}
        </>
      )}
    </>
  );
};

UnavailableSeat.propTypes = {
  unavailableSeatsWithBookings: PropTypes.arrayOf(
    PropTypes.shape({
      coach: PropTypes.string,
      seat: PropTypes.string,
      reference: PropTypes.string
    })
  ),
  unavailableSeatsWithoutBookings: PropTypes.arrayOf(
    PropTypes.shape({
      coach: PropTypes.string,
      seat: PropTypes.string,
      inventoryClass: PropTypes.string
    })
  ),
  currentCoach: PropTypes.string,
  reference: PropTypes.string
};

export default UnavailableSeat;
